/** @format */

import * as Sentry from '@sentry/react'
import React, {StrictMode, Suspense, useEffect} from 'react'
import {createRoot} from 'react-dom/client'
import {RouterProvider} from 'react-router-dom'

import {FullPageLoading} from '@src/components/tailwind/Loading'

import {FormspreeContextProvider, ProductsApiProvider} from '@src/contexts'
import {AccountContextProvider} from '@src/contexts/AccountContext'
import {LoadingContextProvider} from '@src/contexts/LoadingContext'
import {PosthogContextProvider} from '@src/contexts/PosthogContext'

import {initAmplitude, initSentry} from './bootstrap'
import {router} from './RootRouter'

/** @format */

initSentry()

function App() {
  useEffect(() => {
    initAmplitude()
  }, [])

  const isUserOptionalPage = window.location.pathname.match(
    /^\/(plans|login|register)\/?/,
  )

  return (
    <FormspreeContextProvider>
      <PosthogContextProvider>
        <ProductsApiProvider>
          <LoadingContextProvider>
            <AccountContextProvider userOptional={isUserOptionalPage}>
              <Suspense fallback={<FullPageLoading />}>
                <RouterProvider router={router} />
              </Suspense>
            </AccountContextProvider>
          </LoadingContextProvider>
        </ProductsApiProvider>
      </PosthogContextProvider>
    </FormspreeContextProvider>
  )
}

createRoot(document.getElementById('body')).render(
  <StrictMode>
    {window.formspree && window.formspree.SENTRY_DSN_REACT ? (
      <Sentry.ErrorBoundary fallback="An error has occurred" showDialog>
        <App />
      </Sentry.ErrorBoundary>
    ) : (
      <App />
    )}
  </StrictMode>,
)
